export enum Variability {
  Fixed = 'Fixed',
  Variable = 'Variable',
}

export const VARIABILITY_OPTIONS = [
  {
    label: 'Fixed',
    value: Variability.Fixed,
  },
  {
    label: 'Variable',
    value: Variability.Variable,
  },
];
